import {
  BillingTransaction,
  BillingTransactionStats,
  BillingTransactionStatsFilters,
  BillingTransactionsFilters,
  BillingTransactionsListResponse,
  BillingTransactionStatus,
} from "@/types/billing-transactions";
import { BaseService } from "./BaseService";
import { IBillingTransactionsService } from "./interfaces/IBillingTransactionsService";

class BillingTransactionService
  extends BaseService
  implements IBillingTransactionsService
{
  private basePath = "/payments";

  constructor() {
    super();
  }

  async getBillingTransactions(
    filters?: BillingTransactionsFilters,
    page?: number,
    limit?: number,
  ): Promise<BillingTransactionsListResponse> {
    const billingTransactionsFilter = {
      ...filters,
      page,
      limit,
    };

    return this.get<BillingTransactionsListResponse>(
      `${this.basePath}/transactions`,
      billingTransactionsFilter,
    );
  }

  async getBillingTransactionStats(
    filters?: BillingTransactionStatsFilters,
  ): Promise<BillingTransactionStats> {
    return this.get<BillingTransactionStats>(
      `${this.basePath}/transactions/stats`,
      filters,
    );
  }

  async updateTransactionStatus(
    id: string,
    status: BillingTransactionStatus,
  ): Promise<BillingTransaction> {
    return this.patch<BillingTransaction>(
      `${this.basePath}/transactions/${id}/status`,
      { status },
    );
  }

  async getBillingTransactionById(id: string): Promise<BillingTransaction> {
    return this.get<BillingTransaction>(`${this.basePath}/transactions/${id}`);
  }
}

export const billingTransactionService = new BillingTransactionService();
